export default ({ COLORS, FONT_SIZES }) => ({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    padding: '0 25px',
    justifyContent: 'center'
  },
  title: {
    animation: '0.3s fadeIn',
    textAlign: 'left',
    margin: '0',
    display: 'flex',
    alignItems: 'center',
    ...FONT_SIZES.HEADING_DEFAULT.STYLE
  },
  titleBone: {
    width: '100px'
  },
  backToLessons: {
    position: 'absolute',
    left: '25px',
    top: '28px',
    color: COLORS.BLUE.NORMAL,
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center'
  },
  copyButton: {
    position: 'absolute',
    right: '25px',
    top: '16px'
  },
  '@keyframes fadeIn': {
    from: { opacity: '0' },
    to: { opacity: '1' }
  }
})
